import { postResource } from "./services";

export function contactUs(data, onSuccess, onFail) {
  const path = `api/v1/senEmailForMechanicalStaticWebsite`;
  postResource(path, data, onSuccess, onFail);
}
